import SalesDashboard from './menu/SalesDashboard/index.vue'
import SalesDashboardRoutes from './menu/SalesDashboard/router.js'

import SalesUpload from './menu/SalesUpload/index.vue'
import SalesUploadRoutes from './menu/SalesUpload/router.js'

import LockerDashboard from './menu/LockerDashboard/index.vue'
import LockerDashboardRoutes from './menu/LockerDashboard/router.js'

import PnlDashboard from './menu/PnlDashboardNew/index.vue'
import PnlDashboardRoutes from './menu/PnlDashboardNew/router.js'

import PnlUpload from './menu/PnlUploadNew/index.vue'
import PnlUploadRoutes from './menu/PnlUploadNew/router.js'

import Setting from './menu/Setting/index.vue'
import SettingRoutes from './menu/Setting/router.js'


const appRoutes = [
    {
      path: '/salesdashboard',
      name: 'SalesDashboard',
      children: SalesDashboardRoutes,
      component: SalesDashboard
    },
    {
      path: '/salesupload',
      name: 'SalesUpload',
      children: SalesUploadRoutes,
      component: SalesUpload
    },
    {
      path: '/lockerdashboard',
      name: 'LockerDashboard',
      children: LockerDashboardRoutes,
      component: LockerDashboard
    },
    {
      path: '/pnldashboard',
      name: 'PnlDashboard',
      children: PnlDashboardRoutes,
      component: PnlDashboard
    },
    {
      path: '/pnlupload',
      name: 'PnlUpload',
      children: PnlUploadRoutes,
      component: PnlUpload
    },
    {
      path: '/setting',
      name: 'Setting',
      children: SettingRoutes,
      component: Setting
    },
]

export default appRoutes;